import { Box, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

import { MIN_REASON_LENGTH, validateRequestReason } from "../data/types";

const CharacterCount = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: "block",
}));

type RequestReasonFieldProps = {
  value: string;
  onChange: (value: string) => void;
  showValidation?: boolean;
};

function RequestReasonField({
  value,
  onChange,
  showValidation = false,
}: RequestReasonFieldProps) {
  const error = showValidation ? validateRequestReason(value) : null;
  const charCount = value.trim().length;

  return (
    <Box>
      <TextField
        fullWidth
        multiline
        rows={4}
        label="Reason for this access request"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={!!error}
        helperText={error}
      />
      <CharacterCount
        variant="caption"
        color={charCount < MIN_REASON_LENGTH ? "error.main" : "success.main"}
      >
        {charCount}/{MIN_REASON_LENGTH} characters minimum
      </CharacterCount>
    </Box>
  );
}

export default RequestReasonField;
